export default __webpack_public_path__ + "static/media/a13.278a9320.webp";